import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadWaterReadingsSuccess(waterReadings) {
  return { type: types.LOAD_WATER_READINGS_SUCCESS, waterReadings };
}

export function createWaterReadingSuccess(waterReading) {
  return { type: types.CREATE_WATER_READING_SUCCESS, waterReading };
}

export function updateWaterReadingSuccess(waterReading) {
  return { type: types.UPDATE_WATER_READING_SUCCESS, waterReading };
}

export function deleteWaterReadingSuccess(waterReading) {
  return { type: types.DELETE_WATER_READING_SUCCESS, waterReading };
}

export function loadWaterReadings(siteId) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'readings/water/sites/' + siteId;
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadWaterReadingsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveWaterReading(waterReading) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'readings/water';
    if (waterReading.id) {
      url = baseApi + 'readings/water/' + waterReading.id;
      return axios
        .put(url, {
          ...waterReading,
        })
        .then((response) => {
          dispatch(updateWaterReadingSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          siteId: waterReading.siteId,
          timestamp: waterReading.timestamp,
          masterReading: waterReading.masterReading || null,
          freeChlorine: waterReading.freeChlorine,
          totalChlorine: waterReading.totalChlorine,
          chemicalReading: waterReading.chemicalReading
            ? waterReading.chemicalReading
            : null,
          comments: waterReading.comments,
          userId: waterReading.userId,
        })
        .then((response) => {
          dispatch(createWaterReadingSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteWaterReading(waterReading) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'readings/water/' + waterReading.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteWaterReadingSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/waterReadingActions.js